<template>
  <div class="md-layout">
    <div
      class="md-layout-item md-size-25 pl-5"
      v-for="(item, index) in information"
      :key="item + index"
    >
      <md-card class="rounded-2xl mr-auto mt-2 border-1 w-[150px] h-[150px]">
        <md-card-content class="mx-auto text-center flex flex-col h-full">
          <md-icon v-if="item.icon" class="text-[#2D82B5] pt-2 mb-5">
            <i :class="item.icon" class="text-[#2D82B5] text-[47px]"></i>
          </md-icon>
          <img
            v-else
            class="mx-auto w-[50px] h-[45px]"
            src="/img/time-award.svg"
            alt=""
          />
          <p class="text-[#2D82B5] pt-2 grow h-[24px]">
            {{ item.value }}
            {{ item.isMinute ? $t("zoom_meeting.minutes") : "" }}
          </p>
          <h2 class="pt-2">{{ $t(item.name) }}</h2>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>
<script>
export default {
  props: ["information"]
};
</script>
